/**
   Copyright (c)2021 3Key Company s.r.o., All Rights Reserved

   It is strictly prohibited to distribute the source code,
   transpiled and compiled code or its parts without previous
   agreement of the 3Key Company board.
*/

import "./Select.css";

import * as React from "react";

import { SelectProps, SelectState, SelectItem } from "./Select.types";

export default class Select extends React.Component<SelectProps, SelectState> {

   private ref: React.RefObject<HTMLTableSectionElement> = React.createRef();

   private componentClassName: string;

   constructor(props: SelectProps) {

      super(props);

      this.componentClassName = "tk-select" + (this.props.componentName ? `-${this.props.componentName}` : "");

      this.state = {
         ...this.loadItemsFromProps(false)
      }

   }

   public componentDidUpdate(prevProps: SelectProps, prevState: SelectState) {

      if (prevProps.items !== this.props.items) {
         this.loadItemsFromProps(true);
      }

   }

   public render() {

      const items: React.ReactNode[] = [];

      for (let i = 0; i < this.state.items.length; i++) {

         const item = this.state.items[i];

         const checkBox = this.props.hasCheckBoxes ?
            <td key="chb">
               <div className="container">
                  <span className="check-mark" data-checked={item.checked} onMouseDown={() => this.onCheckBoxMouseDown(i)}></span>
               </div>
            </td>
         :
            <></>
         ;

         const columns: React.ReactNode[] = [];

         let content;
         let tooltip = "";

         if (item.value.indexOf("~") !== -1) {
            const tmp = item.value.split("~");
            content = tmp[0];
            tooltip = tmp[1];
         } else {
            content = item.value
         }

         content.split("|").forEach(
            v => columns.push(
               <td key="dta">{v}</td>
            )
         )

         items.push(

            <tr
               key={item.value}
               data-selected={item.selected}
               title={tooltip}
               onMouseDown={(e) => { this.onItemMouseDown(e, item) }}
               onDoubleClick={(e) => { this.onItemDblClick(e, item) }}
            >

               {checkBox}
               {columns}

            </tr>
         )

      }

      const props = this.props.disabled ? {} : { tabIndex: 0 };

      return (

         <div className={this.componentClassName} data-checkboxes={true} {...props} onKeyDown={this.onKeyDown} data-disabled={this.props.disabled}>
            <table>
               <tbody ref={this.ref}>
                  {items}
               </tbody>
            </table>
            <div className="disabler"></div>
         </div>

      )

   }

   private onItemMouseDown = (e: React.MouseEvent, item: SelectItem) => {

      const items = [ ...this.state.items ];

      items.forEach(
         (i, index) => {
            i.selected = i === item
            if (i.selected) this.setState({ selectedIndex: index });
         }
      )

      this.setState({ items })

      if (this.props.hasCheckBoxes && e.detail > 1) e.preventDefault();

   }

   private onItemDblClick = (e: React.MouseEvent, item: SelectItem) => {

      if (this.props.hasCheckBoxes) {
         this.onCheckBoxMouseDown(this.state.selectedIndex);
         e.preventDefault();
         e.stopPropagation();
      }

   }

   private onCheckBoxMouseDown = (itemIndex: number) => {

      const items = [ ...this.state.items ];
      items[itemIndex].checked = !items[itemIndex].checked;

      this.setState({
         items
      })
   }

   private onKeyDown = (e: React.KeyboardEvent) => {

      switch(e.key) {

         case "ArrowUp":
            if (this.state.selectedIndex > 0) this.selectItemAtIndexAndUnselectRest(this.state.selectedIndex - 1);
            break;

         case "ArrowDown":
            if (this.state.selectedIndex < this.state.items.length - 1) this.selectItemAtIndexAndUnselectRest(this.state.selectedIndex + 1);
            break;

         case " ":
            if (this.props.hasCheckBoxes && this.state.selectedIndex >= 0) this.onCheckBoxMouseDown(this.state.selectedIndex);
            e.preventDefault();
            e.stopPropagation();
            break;

      }

   }

   private selectItemAtIndexAndUnselectRest(index: number) {

      const items = [ ...this.state.items ];
      items.forEach(
         (i, idx) => {
            i.selected = idx === index;
            if (i.selected) {
               this.setState({ selectedIndex: idx });
               if (this.ref.current) this.ref.current.children[idx].scrollIntoView(false);
            }
         }
      )

      this.setState({ items });
   }

   private loadItemsFromProps(setState: boolean = false): { items: SelectItem[], selectedIndex: number } {

      const items: SelectItem[] = [];
      let selected = false;
      let selectedIndex: number = -1;

      this.props.items.forEach(
         item => {

            const itm: SelectItem = Object.assign(item);

            if (item.selected && selected && !this.props.multiselect) itm.selected = false;

            if (itm.selected) {
               selected = true;
               selectedIndex = items.length;
            }

            items.push(itm);

         }
      )

      if (setState) {
         this.setState({
            items,
            selectedIndex
         });
      }

      return {
         items,
         selectedIndex
      }

   }


}